import React from 'react';
import { Avatar, Box, Chip, Grid, Stack, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const infoRows = (student) => [
  { label: 'Admission No', value: student?.admissionNumber || 'N/A' },
  { label: 'Class', value: student?.classes?.className || student?.className || 'N/A' },
  { label: 'Section', value: student?.section?.sectionName || 'N/A' },
  { label: 'Academic Year', value: student?.academicYear || 'N/A' },
  { label: 'Parent', value: student?.parentName || 'N/A' },
];

const StudentInfoHeader = ({ student }) => {
  const fullName = `${student?.firstName || ''} ${student?.lastName || ''}`.trim() || 'Student';

  return (
    <Box
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'divider',
        background: 'linear-gradient(135deg, rgba(247,250,255,0.98) 0%, rgba(255,255,255,0.98) 100%)',
      }}
    >
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2.5} alignItems={{ xs: 'flex-start', md: 'center' }}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ minWidth: 0 }}>
          <Avatar
            src={student?.imageUrl || ''}
            sx={{
              width: 92,
              height: 92,
              borderRadius: 1.5,
              bgcolor: 'primary.50',
              color: 'primary.main',
              fontSize: 36,
              boxShadow: '0 14px 34px -24px rgba(37,99,235,0.55)',
            }}
          >
            {!student?.imageUrl ? <PersonIcon fontSize="inherit" /> : null}
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              {fullName}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.4 }}>
              Only the main student details needed for fee work are shown here.
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 1.4 }}>
              <Chip size="small" label={student?.gender || 'Student'} />
              <Chip size="small" label={student?.classes?.className || student?.className || 'Class N/A'} />
              {student?.section?.sectionName ? <Chip size="small" label={`Section ${student.section.sectionName}`} /> : null}
            </Stack>
          </Box>
        </Stack>

        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <Grid container spacing={1.25}>
            {infoRows(student).map((row) => (
              <Grid item xs={12} sm={6} md={4} key={row.label}>
                <Box
                  sx={{
                    p: 1.2,
                    borderRadius: 1.5,
                    bgcolor: 'rgba(15, 23, 42, 0.03)',
                    border: '1px solid rgba(15, 23, 42, 0.06)',
                  }}
                >
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    {row.label}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 700, mt: 0.35 }}>
                    {row.value}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
    </Box>
  );
};

export default StudentInfoHeader;
